module.exports = __webpack_public_path__ + "static/media/emoji-sad-icon.30e1cfd5.svg";